import { s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, e as escape, f as createEventDispatcher, d as add_attribute, v as validate_component } from "../../../../../chunks/ssr.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { D as Dropdown } from "../../../../../chunks/Dropdown.js";
import { S as Spinner } from "../../../../../chunks/Spinner.js";
/* empty css                                                                */
import "../../../../../chunks/project.js";
import "tailwindcss/colors.js";
/* empty css                                                          */
import { p as page } from "../../../../../chunks/stores.js";
import "../../../../../chunks/client.js";
import dayjs from "dayjs";
import { O as OpenButton } from "../../../../../chunks/OpenButton.js";
import { S as SearchFilter } from "../../../../../chunks/SearchFilter.js";
import { C as ChevronDownOutline } from "../../../../../chunks/ChevronDownOutline.js";
import { G as GridOutline } from "../../../../../chunks/GridOutline.js";
import { P as PlusOutline } from "../../../../../chunks/PlusOutline.js";
const ProjectStatus = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value } = $$props;
  let { size = "xs" } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  return `${value === "requested" ? `<span class="${"inline-flex items-center gap-x-1.5 rounded-md bg-yellow-100 px-2 py-1 text-" + escape(size, true) + " font-medium text-yellow-800"}"><svg class="h-1.5 w-1.5 fill-yellow-500" viewBox="0 0 6 6" aria-hidden="true"><circle cx="3" cy="3" r="3"></circle></svg>
      Anfrage</span>` : `${value === "confirmed" ? `<span class="${"inline-flex items-center gap-x-1.5 rounded-md bg-green-100 px-2 py-1 text-" + escape(size, true) + " font-medium text-green-800"}"><svg class="h-1.5 w-1.5 fill-green-500" viewBox="0 0 6 6" aria-hidden="true"><circle cx="3" cy="3" r="3"></circle></svg>
      Auftrag</span>` : `${value === "finished" ? `<span class="${"inline-flex items-center gap-x-1.5 rounded-md bg-coolGray-100 px-2 py-1 text-" + escape(size, true) + " font-medium text-coolGray-800"}"><svg class="h-1.5 w-1.5 fill-coolGray-500" viewBox="0 0 6 6" aria-hidden="true"><circle cx="3" cy="3" r="3"></circle></svg>
      Stunden gebucht</span>` : `${value === "billing" ? `<span class="${"inline-flex items-center gap-x-1.5 rounded-md bg-indigo-100 px-2 py-1 text-" + escape(size, true) + " font-medium text-indigo-800"}"><svg class="h-1.5 w-1.5 fill-indigo-500" viewBox="0 0 6 6" aria-hidden="true"><circle cx="3" cy="3" r="3"></circle></svg>
      Rechnung geschrieben</span>` : `${value === "canceled" ? `<span class="${"inline-flex items-center gap-x-1.5 rounded-md bg-red-100 px-2 py-1 text-" + escape(size, true) + " font-medium text-red-800"}"><svg class="h-1.5 w-1.5 fill-red-500" viewBox="0 0 6 6" aria-hidden="true"><circle cx="3" cy="3" r="3"></circle></svg>
      Storniert</span>` : ``}`}`}`}`}`;
});
const DateDisplay = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  return `<span>${escape(dayjs(value.value || value).format("DD.MM.YYYY"))}</span>`;
});
const Toggle = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value = false } = $$props;
  let { label = "" } = $$props;
  createEventDispatcher();
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  return `<div class="flex items-center gap-2"><button type="button" class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2" role="switch"${add_attribute("aria-checked", value, 0)}><span class="sr-only">${escape(label)}</span> <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white"></span>  <span aria-hidden="true" class="${escape(value ? "bg-primary-600" : "bg-gray-200", true) + " pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"}"></span>  <span aria-hidden="true" class="${escape(value ? "translate-x-5" : "translate-x-0", true) + " translate-x-0 pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"}"></span></button> <span>${escape(label)}</span></div>`;
});
let projectsHeader = [
  {
    property: "customer.registry",
    label: "KdNr",
    sortable: true,
    movable: true,
    class: "w-20",
    render: (row) => row.customer.registry,
    customSort: (a, b, c) => a.customer.registry < b.customer.registry ? c : -1 * c
  },
  {
    property: "associate.lastName",
    label: "Besteller",
    sortable: true,
    movable: true,
    class: "w-38",
    render: (row) => row.responsibleAssociate?.firstName + " " + row.responsibleAssociate?.lastName
    //render: row => '<span class="font-bo,ld">' + row.responsibleUser?.associations?.find(x => x.customerId === row.customerId)?.name + '</span>',
    //customSort: (a, b, c) => a.responsibleUser?.associations.find(x => x.customerId === a.customerId)?.name < b.responsibleUser?.associations.find(x => x.customerId === b.customerId)?.name ? c : -1*c
  },
  {
    property: "customerId",
    label: "Kunde",
    movable: true,
    sortable: true,
    render: (row) => row.customer.name
  },
  {
    label: "Titel",
    property: "name",
    sortable: true,
    movable: true
  },
  {
    label: "Status",
    property: "status",
    component: ProjectStatus,
    sortable: true,
    movable: true
  },
  {
    label: "Beginn",
    property: "startsAt",
    component: DateDisplay,
    sortable: true,
    movable: true
  },
  {
    label: "Öffnen",
    property: "uuid",
    component: OpenButton,
    props: {
      onClick: (uuid) => location.href = "/project/" + uuid
    },
    class: "w-16",
    movable: false
  }
];
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => value);
  let { data } = $$props;
  let header = projectsHeader;
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  $$unsubscribe_page();
  return `<section>${validate_component(SearchFilter, "SearchFilter").$$render($$result, {}, {}, {
    cta: () => {
      return `<div>${validate_component(Button, "Button").$$render($$result, {}, {}, {
        default: () => {
          return `Status
                    ${validate_component(ChevronDownOutline, "ChevronDownOutline").$$render($$result, { class: "w-3 h-3 ml-2" }, {}, {})}`;
        }
      })} ${validate_component(Dropdown, "Dropdown").$$render($$result, { class: "w-52 p-3 space-y-3 text-sm" }, {}, {
        default: () => {
          return `<li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem" tabindex="-1" data-svelte-h="svelte-78euna">Alle</button></li> <li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem" tabindex="-1" data-svelte-h="svelte-1yqza36">Anfrage</button></li> <li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem" tabindex="-1" data-svelte-h="svelte-1gupjlr">Auftrag</button></li> <li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem" tabindex="-1" data-svelte-h="svelte-168izgj">Stunden gebucht</button></li> <li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem" tabindex="-1" data-svelte-h="svelte-gzkewo">Rechnung geschrieben</button></li> <li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800" role="menuitem" tabindex="-1" data-svelte-h="svelte-f9kyh9">Storniert</button></li>`;
        }
      })}</div> ${validate_component(Button, "Button").$$render($$result, { href: "/create/project" }, {}, {
        default: () => {
          return `${validate_component(PlusOutline, "PlusOutline").$$render($$result, { class: "w-3 h-3 mr-1" }, {}, {})}
                Projekt`;
        }
      })} ${validate_component(Button, "Button").$$render($$result, { color: "alternative" }, {}, {
        default: () => {
          return `${validate_component(GridOutline, "GridOutline").$$render($$result, { class: "w-3 h-3 mr-2" }, {}, {})}
                Ansicht`;
        }
      })} ${`<div>${validate_component(Button, "Button").$$render($$result, { color: "alternative" }, {}, {
        default: () => {
          return `Spalten
                        ${validate_component(ChevronDownOutline, "ChevronDownOutline").$$render($$result, { class: "w-3 h-3 ml-2" }, {}, {})}`;
        }
      })} ${validate_component(Dropdown, "Dropdown").$$render($$result, { class: "w-44 p-3 space-y-3 text-sm" }, {}, {
        default: () => {
          return `<li class="p-2 flex gap-3 items-center">${validate_component(Toggle, "Toggle").$$render(
            $$result,
            {
              label: "Kundennummer",
              value: header.find((x) => x.property === "customer.registry")
            },
            {},
            {}
          )}</li> <li class="p-2 flex gap-3 items-center">${validate_component(Toggle, "Toggle").$$render(
            $$result,
            {
              label: "Kunde",
              value: header.find((x) => x.property === "customerId")
            },
            {},
            {}
          )}</li> <li class="p-2 flex gap-3 items-center">${validate_component(Toggle, "Toggle").$$render(
            $$result,
            {
              label: "Status",
              value: header.find((x) => x.property === "status")
            },
            {},
            {}
          )}</li>`;
        }
      })}</div>`}`;
    }
  })} ${`<div class="text-center my-5">${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}</div>`}</section>`;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
